import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  useLocation
} from "react-router-dom";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser } from '@fortawesome/free-solid-svg-icons';

import ChatWidget from './components/ChatWidget';

import 'react-chat-widget/lib/styles.css';

library.add(faUser);

const useQuery = () => {
  console.log(useLocation().search)
  let params = new URLSearchParams(useLocation().search);
  return params;
}

//The app has a router only to access the URL query parameters
const App = () => {
  return (
    <>
      <Router>
        <UrlParam/>
      </Router>
    </>
  )
}

//This retrieves the widgetId and returns the ChatWidget.  This might
//be a good place to retrieve any data about this widget and pass it in as a prop
//to ChatWidget
// So make a request to get widget data, but the server will check this referrer as allowed
//before returning the data
const UrlParam = () => {
  let query = useQuery();
  let widgetId = query.get("widget_id");
  let userAgent = navigator && navigator.userAgent;
  console.log(userAgent);


  // const [widgetId, setWidgetId] = useState();
  // const [loading, setLoading] = useState(true);
  const [widgetData, setWidgetData] = useState(null);

  useEffect(() => {
    let body = { widgetId: widgetId };
    body.userAgent = userAgent ? userAgent : false;
    console.log(body)
    try {
      fetch("/widgets", {
        method: "post",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        return response.json();
      }).then(json => {
        console.log(json)
        setWidgetData(json)
        // setLoading(false)
      })
    } catch(err) {
      console.log(err)
    }
  }, [widgetId, userAgent])

  if(!widgetData) {
    return (<>Loading...</>)
  }

  // Optionally load different widgets with special stylings that will
  // then implement ChatWidget, falling back on ChatWidget if no option
  // This should include props for styling, retrieved from widgetData
  // {
  //   color: "STRING", //done
  //   connect_message: "STRING", //done
  //   init_message: "STRING", //done, not tested
  //   start_type: "STRING",
  //   title: "STRING"
  // }
  return (
    <ChatWidget
      options={widgetData}
    />
  )

}

export default App;
